import { takeExistingFilterValue } from "./takeExistingFilterValue.js";
const getFiltersQueryValues = (queryParams, filterGridItems, filterValuesItem) => {
  const result = {};
  const filterValuesItemData = filterValuesItem == null ? void 0 : filterValuesItem.data;
  if (!filterValuesItemData) {
    return result;
  }
  Object.entries(queryParams).forEach(([queryKey, queryValue]) => {
    const filterKey = queryKey;
    const filterValues = filterValuesItemData == null ? void 0 : filterValuesItemData[filterKey];
    const filterGridItem = filterGridItems.find((filterGridItem2) => filterGridItem2.key === filterKey);
    const resolvedQueryValues = queryValue.split("|").reduce((acc, value) => {
      try {
        if (!value.length) {
          return acc;
        }
        return [...acc, JSON.parse(value)];
      } catch {
        return [...acc, value];
      }
    }, []);
    if (!filterValues || !filterGridItem) {
      return;
    }
    const existingFilterValue = takeExistingFilterValue(resolvedQueryValues, filterValues, filterGridItem);
    if (typeof existingFilterValue !== "undefined") {
      result[filterGridItem.key] = existingFilterValue;
    }
  });
  return result;
};
export {
  getFiltersQueryValues
};
